<template>
  <div>
    <div class="form-group">
      <div v-if="isStaff(currentUser)" class="pull-right">
        <div class="dropdown dropdown-menu-right">
          <button id="dLabel" class="btn btn-default btn-sm" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Valitse valmis vastausvaihtoehto...
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dLabel">
            <li v-for="template in responseTemplates" :key="template.id">
              <a @click.prevent="selectTemplate(template.id)" href="#">
                {{ template.text }}...
              </a>
            </li>

            <li role="separator" class="divider"></li>
            <li><a href="/staff/vastausvaihtoehto">Lisää vastausvaihtoehto...</a></li>
            <li><a :href="signatureUrl">Muuta allekirjoitus...</a></li>
          </ul>
        </div>

        <p v-if="!currentUser.signature" class="help-block">Voit asettaa allekirjoituksen <a :href="signatureUrl">täällä</a></p>
      </div>

      <textarea 
        v-model="message"
        rows="8" 
        class="form-control" 
        name="message" 
        id="viesti"
      ></textarea>
    </div>

    <div class="form-group" style="margin-top: -5px;">
      <label for="liitteet" class="control-label">
        Liitteet:
      </label>

      <div 
        v-for="attachment in attachments" 
        :key="attachment.id" 
        :class="{ 'deleted-line-through': deleteAttachmentId == attachment.id }"
        class="small-vertical-margins">
          <a :href="`/storage/${attachment.filename}`" target="_blank">{{ attachment.filename }} <i class="fa fa-external-link"></i></a>
          <i
            @click="confirmDelete(attachment.id)"     
            class="fa fa-trash attachment-delete" 
            aria-hidden="true">
          </i>
      </div>

      <br v-if="attachments.length >0" />

      <input 
        ref="fileInput"
        type="file" 
        id="liitteet" 
        style="display: inline-block; margin-left: 20px;" 
        name="attachments[]" 
        multiple>
    </div>

    <p v-if="error" class="text-danger">
      Lähetys epäonnistui: {{ error }}
    </p>

    <button @click="saveQuery" type="button" class="btn btn-primary" :disabled="!message">
      <span v-if="isNewQuery">Lähetä</span>
      <span v-else>Päivitä</span>
    </button>

    <button v-if="!isNewQuery" @click="reloadQueries" type="button" class="btn btn-default">Peruuta</button>
    <button v-if="backUrl" type="button" class="btn btn-default back-url" :value="backUrl">Takaisin</button>

    <div v-if="fastQuery && !isStaff(currentUser)" style="float: right; margin-right: 4px;">
      <follow-product-button  :product-id="productId" />

      <karhu-button
        :product-id="productId" 
        :parent-id="parentId" 
        :current-user="currentUser" 
        :product-kuvailu-tulossa="productKuvailuTulossa"
        @reload-queries="reloadQueries"
      />
    </div>
  </div>
 </template>

<script>

import { userMixin } from '@/mixins/userMixin.js'
import FollowProductButton from './FollowProductButton.vue'
import KarhuButton from './KarhuButton.vue'

export default {
  components: { FollowProductButton, KarhuButton },
    
  emits: ['reload-queries'],

  mixins: [
    userMixin,
  ],

  props: {
    query: Object,
    currentUser: Object,
    responseTemplates: Array,
    productId: String,
    parentId: String,
    backUrl: String,
    fastQuery: Boolean,
    productKuvailuTulossa: Boolean,
  },

  data() {
    return {
      message: this.query ? this.query.message : null,

      editing: true,
      error: null,

      attachments: this.query ? this.query.attachments : [],
      deleteAttachmentId: null,
    }
  },

  computed: {
    isNewQuery() {
      return this.query ? false : true
    },

    isKohdistamatonKarhu() {
      return this.productId ? false : true
    },

    signatureUrl() {
      return `/staff/user/${this.currentUser.id}/edit`
    },
  },

  watch: {
    query(value) {
      this.attachments = this.query.attachments
    },
  },

  methods: {

    saveQuery() {
      const formData = this.makeFormData()
      const config = this.makeConfig(formData)

      this.sendQuery(config)
    },

    sendQuery(config) {
      this.error = ''
      
      axios(config)
      .then((response) => {
        console.log(response)

        if (response.data.error) {
          this.error = response.data.error

          return
        }

        this.reloadQueries()

        if (this.isNewQuery) {
          this.message = null
        }
      })
      .catch((error) => {
        this.error = error
        console.log(error)
      })
      .finally(() => {
        //
      });

    },

    makeConfig(formData) {
      let config = null

      if (this.isNewQuery) {
        config = {
          url: `/luettelointi/kysely`,
          method: 'post',
          data: formData,
          headers: {"Content-Type": "multipart/form-data"},
        }
      } else {
        config = {
          url: `/luettelointi/kysely/${this.query.id}`,
          method: 'post',
          data: formData,
          headers: {"Content-Type": "multipart/form-data"},
        }
      }

      return config
    },

    makeFormData() {
      let formData = new FormData()

      if (this.isNewQuery) {
        formData.append("parent_id", this.parentId)  
        formData.append("product_id", this.productId)  
      } else {
        formData.append("_method", "patch")   // PHP requires this: https://stackoverflow.com/questions/47676134/laravel-request-all-is-empty-using-multipart-form-data
      }

      formData.append("message", this.message)

      const files = Array.from(this.$refs.fileInput.files) // turn Object into Array

      files.forEach( (file) => {
        formData.append("attachments[]", file)
      })

      return formData
    },

    selectTemplate(id) {
      const template = this.responseTemplates.filter( (template) => {return template.id == id} )[0]

      this.message = template.text

      if (this.currentUser.signature) {
        this.message += `\n${this.currentUser.signature}`
      }
    },

    confirmDelete(id) {
      const self = this

      bootbox.confirm("Oletko varma että haluat tuhota tämän?", function(result){
        if (result) {
          self.deleteAttachment(id)
        }
      })
    },

    deleteAttachment(id) {
      this.deleteAttachmentId = id

      axios.delete(`/luettelointi/kysely/${this.query.id}/attachments/${id}`)
      .then((response) => {
        console.log(response)

        this.attachments = this.attachments.filter((item) => {return item.id != this.deleteAttachmentId})
      })
      .catch((error) => {
        this.error = error
        console.log(error)
      })
      .finally(() => {
        //
      });
    },

    reloadQueries() {
      this.$refs.fileInput.value = null;

      this.$emit('reload-queries')
    },

  },

}
</script>

<style scoped>

  .deleted-line-through {
    text-decoration: line-through;
  }

  .small-vertical-margins {
    margin: 5px 0 5px 0;
  }

  .attachment-delete {
    cursor: pointer; margin-left: 10px;
  }
</style>
